// Replacement for https://lodash.com/docs/4.17.15#capitalize
export const capitalize = (value: string) => `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`;
// Replacement for https://lodash.com/docs/4.17.15#capitalize
export const capitalize = (value: string) => `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`;
